module.exports = "/_next/static/images/SecondIntroduceImg-48d9e5b860bc4eee4678e892a4dcda30.png";